import { render, staticRenderFns } from "./TalkBranch.vue?vue&type=template&id=07aec6ba&scoped=true&"
import script from "./TalkBranch.vue?vue&type=script&lang=ts&"
export * from "./TalkBranch.vue?vue&type=script&lang=ts&"
import style0 from "./TalkBranch.vue?vue&type=style&index=0&id=07aec6ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aec6ba",
  null
  
)

export default component.exports